import { render, staticRenderFns } from "./AuthoriseOpgOld.vue?vue&type=template&id=600cb5d8"
import script from "./AuthoriseOpgOld.vue?vue&type=script&lang=js"
export * from "./AuthoriseOpgOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports